/* eslint-disable jira/filename-case */
import { fg } from '@atlassian/jira-feature-gating';

const isEpicColorFGEnabled = {
	get(): boolean {
		return fg('issue-view-layout-epic-color-fg');
	},
};

export default isEpicColorFGEnabled;
